@if (content) {
  <main class="container-fluid">
    <div class="row row-eq-height" >
      <!--Recent activity-->
      <aside class="col-2">
        <div>
          <p class="lead">Course Progress</p>
          <div class="progress">
            <div class="progress-bar bg-success" role="progressbar"
              [ngStyle]="{'min-width.%': courseProgressPercentage === 0 ? 0 : 10,'width.%': courseProgressPercentage}"
              [attr.aria-valuenow]=10 aria-valuemin="0"
              aria-valuemax="100">
              {{ courseProgressPercentage | number:'1.0-0' }}&#37;
            </div>
          </div>
          <hr>
            <ng-container>
              <p class="lead">Last Exercise</p>
              <h5>
                <i class="fa fa-bullseye"></i>
                {{ lastExerciseAccuracy | number:'1.2-2' }}&#37;
              </h5>
              <small>Accuracy</small>
              <h5>
                <i class="fa fa-stopwatch"></i>
                {{ lastExerciseAverageTime | time }}
              </h5>
              <small>Per Question</small>
              <hr>
              </ng-container>
              <p class="lead">All Time</p>
              <h5>
                <i class="fa fa-bullseye"></i>
                {{ lifetimeAccuracy | number:'1.2-2' }}&#37;
              </h5>
              <small>Accuracy</small>
              <h5>
                <i class="fa fa-stopwatch"></i>
                {{ lifetimeAverageTime | time }}
              </h5>
              <small>Per Question</small>
              <h5>
                <i class="fa fa-bolt"></i>
                {{ persistenceRounds | number:'1.0-0' }}
              </h5>
              <small>Persistence Rounds</small>
              <h5>
                <i class="fa fa-lightbulb"></i>
                {{ exercisesRepeated | number:'1.0-0' }}
              </h5>
              <small>Exercises Repeated</small>
            </div>
          </aside>
          <!-- End Recent Activity-->
          <!-- Lessons -->
          @if (lessons && activeCourse) {
            <section class="col-10 lessons">
              <h1>{{ activeCourse.title }}</h1>
              <ul ngbNav #t="ngbNav" class="nav-pills nav-fill" (navChange)="onSelectSubject($event)">
                @if (lessons) {
                  @for (subject of transformSubjectsToList(activeCourse.subject); track subject) {
                    <li [ngbNavItem]="subject">
                      <a ngbNavLink>{{ subject }}</a>
                      <ng-template ngbNavContent>
                        <app-dashboard-subject [courseId]="activeCourse.id" [subject]="subject" [lessons]="lessons" [video]="getVideoBasedOnSubject(subject)"></app-dashboard-subject>
                      </ng-template>
                    </li>
                  }
                  <!--
                  <ngb-tab title="ACT Science" id="ACT Science" (click)="onSelectSubject('ACT Science')">
                    <ng-template ngbTabContent>
                      <app-dashboard-subject [subject]="'ACT Science'" [lessons]="lessons" [video]="content.scienceVideo"></app-dashboard-subject>
                    </ng-template>
                  </ngb-tab>
                  -->
                } @else {
                  <app-spinner></app-spinner>
                }
              </ul>
              <div [ngbNavOutlet]="t"></div>
            </section>
          }
          <!-- End Lessons -->
        </div>
      </main>
    }

